exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel {\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/panel/panel.component.css
// module id = ../../../../../src/app/panel/panel.component.css
// module chunks = main